module.exports = __webpack_public_path__ + "img/equipment_layout_sample.d47c587c.png";